import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import {
  Col,
  Row,
} from 'react-bootstrap';
import { observer } from 'mobx-react';
import DateTimePicker from 'react-datetime';
import { Loader } from '../../components/PageLoading/PageLoading';
import { withTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import { toNumber } from '../../utils/numbers';
import {
  displayDate,
  getLocaleName,
} from '../../utils/date';

const Report = observer((props) => {
  const { t } = props;
  const { ticketStore, printStore, newAuthStore, locationsStore } = useStores();
  const [ loading, setLoading ] = useState(false);
  const [ sold, setSold ] = useState(0);
  const [ produced, setProduced ] = useState(0);
  const [ totalTickets, setTotalTickets ] = useState(0);
  const { tickets, ticketsDateFrom, ticketsDateTo } = ticketStore;
  const { user } = newAuthStore;
  const unit = ticketStore.getTotalUnit();

  const calculateData = useCallback((tickets = []) => {
    const data = tickets.filter(v => !v.isDemo);
    let s = 0, p = 0;

    data.forEach(t => {
      if (t.products && t.products.length) {
        const mix = t.products?.find(v => v.isMix);
        if (mix) {
          s += mix.quantity;
          p += (mix.quantity - mix.quantityInTruck);
        }
      }
    });

    setTotalTickets(data.length);
    setProduced(p);
    setSold(s);
  }, []);

  useEffect(() => {
    calculateData(tickets);
  }, [tickets, calculateData]);

  const printReport = () => {
    const html = document.querySelector('.report-content').innerHTML;
    let logo = document.querySelector('.navbar-brand').innerHTML;
    logo = `<span class="logo">${logo}</span>`;
    let css = '.logo img { max-width: 80px; max-height: 80px }';

    printStore.printHtml(`
        ${logo}
        ${html}
      `, `${css}`);
  };

  const search = () => {
    setLoading(true);
    ticketStore.loadTickets()
      .then((tickets) => {
        calculateData(tickets);
        setLoading(false);
      });
  };

  const onChangeDate = fieldName => value => {
    ticketStore[fieldName] = value;
    search();
  };

  const validFrom = (date) => date.isSameOrBefore(ticketStore.ticketsDateTo);
  const validTo = (date) => date.isSameOrAfter(ticketStore.ticketsDateFrom);

  return (
    <Row className="ticket-mngt">
      <Col sm={12}>
        <Row>
          <Col sm={12}>
            <a className="btn btn-sm btn-simple hidden-xs" onClick={() => printReport()}>
              <i className="fa fa-print"/> {t('Print')}
            </a>

            <div className="input-group input-large date-picker input-daterange pull-right">
              <DateTimePicker
                inputProps={{ className: 'form-control', placeholder: 'date from' }}
                onChange={onChangeDate('ticketsDateFrom')}
                value={ticketsDateFrom}
                timeFormat={true}
                closeOnSelect={true}
                isValidDate={validFrom}
                locale={getLocaleName(user.language)}
              />
              <span className="input-group-addon"> - </span>
              <DateTimePicker
                inputProps={{ className: 'form-control', placeholder: 'date to' }}
                onChange={onChangeDate('ticketsDateTo')}
                value={ticketsDateTo}
                timeFormat={true}
                closeOnSelect={true}
                isValidDate={validTo}
                locale={getLocaleName(user.language)}
              />
            </div>
          </Col>
        </Row>
        {loading ? <Loader/> : (
          <Row>
            <Col sm={12} className="report-content">
              <p/>
              <p><strong>{t('Plant')}</strong>: {locationsStore.currentPlant.description}</p>
              <p><strong>{t('Date')}</strong>: {displayDate(ticketStore.ticketsDateFrom, ticketStore.timezone, 'L LT', newAuthStore.user?.language)} - {displayDate(ticketStore.ticketsDateTo, ticketStore.timezone, 'L LT', newAuthStore.user?.language)}</p>
              <p><strong>{t('Sold')}</strong>: {toNumber(sold, 2)} {unit}</p>
              <p><strong>{t('Produced')}</strong>: {toNumber(produced, 2)} {unit}</p>
              <p><strong>{t('Total Loads')}</strong>: {totalTickets}</p>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
});

export default withTranslation()(Report);
